import { useEffect } from 'react';
import { TRIAL_BANNER_COMPONENT, trialBannerComponentDef } from 'navigation-components/config';
import { useComponentProps, useToggleComponent } from 'navigation-components/platform/hooks';
import { captureException } from '../../../utils/sentryAPI';
import { getHasTrialBanners } from '../api/trialBannerApi';
export const LoadTrialBanner = () => {
  const {
    toggle
  } = useToggleComponent(TRIAL_BANNER_COMPONENT, {
    useScheduler: true
  });
  const updatePromptProps = useComponentProps(trialBannerComponentDef);
  useEffect(() => {
    getHasTrialBanners().then(hasTrialBanners => {
      if (hasTrialBanners) {
        updatePromptProps({
          hasTrialBanners: true
        });
        toggle(true);
      }
    }).catch(error => {
      captureException(error);
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // We don't want to render anything in the DOM as this component is just used for its side effect
  return null;
};